import type { ReactNode, FC } from 'react';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import s from './PlaygroundEmptyStateDesktop.scss';

interface Props {
  logo: ReactNode;
  heading: ReactNode;
  description: ReactNode;
  callToAction?: ReactNode;
  disclaimer?: ReactNode;
  postfix: ReactNode;
}

const PlaygroundEmptyStateDesktop: FC<Props> = ({
  logo,
  heading,
  description,
  callToAction,
  postfix,
  disclaimer,
}) => {
  return (
    <Section className={s['root']}>
      <div className={s['main-and-disclaimer']}>
        <div className={s['logo-text-and-cta']}>
          <span>{logo}</span>
          <div className={s['text-section']}>
            <Heading className={s['heading']}>{heading}</Heading>
            <p className={s['description']}>{description}</p>
          </div>
          {callToAction && <span>{callToAction}</span>}
        </div>
        {disclaimer && <p className={s['disclaimer']}>{disclaimer}</p>}
      </div>
      {postfix}
    </Section>
  );
};

PlaygroundEmptyStateDesktop.displayName = 'PlaygroundEmptyStateDesktop';

export default PlaygroundEmptyStateDesktop;
